webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(232);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(195);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(231);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(230);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueLazyload = __webpack_require__(194);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	var _vueProgressbar = __webpack_require__(229);
	
	var _vueProgressbar2 = _interopRequireDefault(_vueProgressbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueLazyload2.default, {
	  preLoad: 1.3,
	  attempt: 1
	});
	_vue2.default.use(_vueProgressbar2.default, {
	  color: 'rgba(0,120,255,1)',
	  failedColor: 'red',
	  thickness: '2px'
	});
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: [{
	    path: '/:language/',
	    name: 'home'
	  }, {
	    path: '/:language/overons/',
	    name: 'overons'
	  }, {
	    path: '/:language/meedoen/',
	    name: 'meedoen'
	  }, {
	    path: '/:language/programma/',
	    name: 'programma'
	  }, {
	    path: '/:language/nieuws/',
	    name: 'nieuws'
	  }, {
	    path: '/:language/verdieping/',
	    name: 'verdieping'
	  }, {
	    path: '/:language/zoek/:slug',
	    name: 'zoek'
	  }, {
	    path: '/:language/tag/:slug',
	    name: 'tag'
	  }, {
	    path: '/:language/verdieping-archief',
	    name: 'verdieping-archief'
	  }, {
	    path: '/:language/verdieping-programma',
	    name: 'verdieping-programma'
	  }, {
	    path: '/:language/verdieping-essays',
	    name: 'verdieping-essays'
	  }, {
	    path: '/:language/verdieping-mapping',
	    name: 'verdieping-mapping'
	  }, {
	    path: '/:language/verdieping-links-naar-meer',
	    name: 'verdieping-links-naar-meer'
	  }, {
	    path: '/:language/verdieping-klankbordgroep',
	    name: 'verdieping-klankbordgroep'
	  }, {
	    path: '/:language/:slug/',
	    name: 'single'
	  }]
	});
	
	window.app = new _vue2.default({
	  el: '#app',
	  router: router,
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  grid: {}
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(172)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(152),
	  /* template */
	  __webpack_require__(223),
	  /* scopeId */
	  "data-v-9029f210",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(161)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(156),
	  /* template */
	  __webpack_require__(212),
	  /* scopeId */
	  "data-v-198a2cfd",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.826a3d2.png";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(167)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(148),
	  /* template */
	  __webpack_require__(218),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(174)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(157),
	  /* template */
	  __webpack_require__(225),
	  /* scopeId */
	  "data-v-a1278e9c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsSideBar = __webpack_require__(207);
	
	var _dsSideBar2 = _interopRequireDefault(_dsSideBar);
	
	var _dsHeader = __webpack_require__(203);
	
	var _dsHeader2 = _interopRequireDefault(_dsHeader);
	
	var _dsFeatured = __webpack_require__(198);
	
	var _dsFeatured2 = _interopRequireDefault(_dsFeatured);
	
	var _dsGrid = __webpack_require__(202);
	
	var _dsGrid2 = _interopRequireDefault(_dsGrid);
	
	var _dsTags = __webpack_require__(139);
	
	var _dsTags2 = _interopRequireDefault(_dsTags);
	
	var _dsSectionIntro = __webpack_require__(206);
	
	var _dsSectionIntro2 = _interopRequireDefault(_dsSectionIntro);
	
	var _dsFooter = __webpack_require__(201);
	
	var _dsFooter2 = _interopRequireDefault(_dsFooter);
	
	var _dsTagItemInline = __webpack_require__(8);
	
	var _dsTagItemInline2 = _interopRequireDefault(_dsTagItemInline);
	
	var _dsTeamItem = __webpack_require__(209);
	
	var _dsTeamItem2 = _interopRequireDefault(_dsTeamItem);
	
	var _dsGridItem = __webpack_require__(138);
	
	var _dsGridItem2 = _interopRequireDefault(_dsGridItem);
	
	var _lokijs = __webpack_require__(184);
	
	var _lokijs2 = _interopRequireDefault(_lokijs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BASE_URL = '//datastudio-eindhoven.nl/proxy.php?http://141.138.193.31/~datastudio/api/wp-json/wp/v2/';
	
	var EVENT_CAT_ID = 5;
	var FEATURED_CAT_ID = 3;
	var BLOG_CAT_ID = 2;
	var NIEUWS_CAT_ID = 4;
	
	var QUOTES_ID = 697;
	var MEEDOEN_ID = 32;
	var OVERONS_ID = 696;
	var NIEUWS_INTRO_ID = 620;
	var PROGRAMMA_INTRO_ID = 26;
	var VERDIEPING_INTRO_ID = 623;
	
	var VERDIEPING_ARCHIEF_INTRO_ID = 655;
	var VERDIEPING_PROGRAMMA_INTRO_ID = 632;
	var VERDIEPING_ESSAYS_INTRO_ID = 635;
	var VERDIEPING_MAPPING_INTRO_ID = 658;
	var VERDIEPING_KLANKBORDGROEP_INTRO_ID = 664;
	var VERDIEPING_LINKSNAARMEER_INTRO_ID = 661;
	
	var VERDIEPING_ARCHIEF_CAT_ID = 8;
	var VERDIEPING_ESSAYS_CAT_ID = 14;
	var VERDIEPING_KLANKBORDGROEP_CAT_ID = 15;
	
	exports.default = {
	  name: 'app',
	  components: {
	    dsSideBar: _dsSideBar2.default,
	    dsHeader: _dsHeader2.default,
	    dsFooter: _dsFooter2.default,
	    dsFeatured: _dsFeatured2.default,
	    dsGrid: _dsGrid2.default,
	    dsGridItem: _dsGridItem2.default,
	    dsTags: _dsTags2.default,
	    dsSectionIntro: _dsSectionIntro2.default,
	    dsTagItemInline: _dsTagItemInline2.default,
	    dsTeamItem: _dsTeamItem2.default
	  },
	  db: {},
	  postCollection: {},
	  pageCollection: {},
	  categoryCollection: {},
	  data: function data() {
	    return {
	      filter: '',
	      tagCollection: {},
	      logoHidden: false,
	      language: 'nl',
	      about: {
	        nl: '',
	        en: 'english about text'
	      },
	      quotes: {
	        en: '',
	        nl: ''
	      },
	      currentTag: '',
	      currentSearchTerm: 'yyyy',
	      tags: [],
	      screenSize: {
	        medium: false,
	        mobile: false
	      },
	      posts: {
	        all: {},
	        featured: {},
	        programma: [{}],
	        nieuws: {},
	        related: {},
	        verdieping: {},
	        search: {},
	        first: {},
	        essays: {},
	        klankbordgroep: {},
	        archief: {},
	        tag: {},
	        single: {
	          acf: {}
	        }
	      },
	      overonsPost: {},
	      meedoenPost: {},
	      filters: [],
	      location: {
	        home: true,
	        single: false,
	        overons: false,
	        meedoen: false,
	        nieuws: false,
	        programma: false,
	        verdieping: false,
	        zoek: false,
	        tag: false,
	        'verdieping-archief': false,
	        'verdieping-programma': false,
	        'verdieping-essays': false,
	        'verdieping-mapping': false,
	        'verdieping-links-naar-meer': false,
	        'verdieping-klankbordgroep': false
	      },
	      loaded: {
	        posts: false,
	        pages: false,
	        quotes: false,
	        about: false,
	        overons: false,
	        meedoen: false,
	        tags: false,
	        tagSearch: false,
	        cats: false
	      },
	      intro: {
	        programma: {},
	        verdieping: {},
	        nieuws: {},
	        verdiepingArchief: {},
	        verdiepingProgramma: {},
	        verdiepingEssays: {},
	        verdiepingMapping: {},
	        verdiepingLinksNaarMeer: {},
	        verdiepingKlankbordgroep: {}
	      }
	    };
	  },
	
	  computed: {
	    specialCategory: function specialCategory() {
	      if (this.posts.single.categories.indexOf(VERDIEPING_ARCHIEF_CAT_ID) > -1) {
	        return {
	          name: 'Archief',
	          slug: 'verdieping-archief'
	        };
	      } else if (this.posts.single.categories.indexOf(VERDIEPING_ESSAYS_CAT_ID) > -1) {
	        return {
	          name: 'Essays',
	          slug: 'verdieping-essays'
	        };
	      }
	      return false;
	    },
	    relatedPosts: function relatedPosts() {
	      var relatedArticles = [];
	      if (this.posts.single.acf.related_articles) {
	        for (var i = 0; i < this.posts.single.acf.related_articles.length; i++) {
	          relatedArticles.push(this.postCollection.findOne({
	            id: this.posts.single.acf.related_articles[i].ID
	          }));
	        }
	        return relatedArticles;
	      } else {
	        return false;
	      }
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    this.$Progress.start();
	    this.db = new _lokijs2.default('test.json');
	    this.postCollection = this.db.addCollection('posts');
	    this.pageCollection = this.db.addCollection('pages');
	    this.tagCollection = this.db.addCollection('tags');
	    this.categoryCollection = this.db.addCollection('category');
	    this.fetchPosts(function () {
	      _this.setLanguage();
	      if (_this.$route.name) {
	        if (_this.$route.name === 'single') {
	          var p = _this.postCollection.where(function (post) {
	            return post.slug === _this.$route.params.slug;
	          });
	          _this.posts.single = p[0];
	          _this.setLocation('single');
	        } else if (_this.$route.name === 'tag') {
	          _this.loaded.tagSearch = false;
	          var tempTag = _this.tagCollection.findOne({
	            slug: _this.$route.params.slug
	          });
	          _this.posts.tag = _this.postCollection.where(function (post) {
	            return post.tags.indexOf(tempTag.id) > -1;
	          });
	          _this.setLocation('tag');
	          _this.currentTag = tempTag;
	          _this.loaded.tagSearch = true;
	        } else if (_this.$route.name === 'zoek') {
	          _this.loaded.search = false;
	          _this.$http.get(BASE_URL + 'posts?search=' + _this.$route.params.slug).then(function (response) {
	            _this.posts.search = response.body;
	            _this.setLocation('zoek');
	            _this.loaded.search = true;
	          }, function (response) {
	            console.error(response);
	          });
	        } else {
	          _this.setLocation(_this.$route.name);
	        }
	      } else {
	        _this.setLocation('home');
	      }
	      _this.loaded.posts = true;
	    });
	    this.fetchPages(function () {
	      _this.loaded.about = true;
	      _this.loaded.quotes = true;
	      _this.loaded.meedoen = true;
	      _this.loaded.overons = true;
	      _this.loaded.pages = true;
	    });
	    this.fetchTags(function () {
	      _this.loaded.tags = true;
	    });
	    this.fetchCategories(function () {
	      _this.loaded.cats = true;
	    });
	    this.mediaWatcher();
	  },
	  mounted: function mounted() {
	    if (window.matchMedia('(max-width: 520px)').matches) {
	      this.screenSize.mobile = true;
	    } else {
	      this.screenSize.mobile = false;
	    }
	  },
	
	  methods: {
	    fetchPosts: function fetchPosts(cb) {
	      var _this2 = this;
	
	      this.$http.get(BASE_URL + 'posts?per_page=100&order=asc').then(function (response) {
	        for (var i = 0; i < response.body.length; i++) {
	          _this2.postCollection.insert(response.body[i]);
	        }
	        _this2.posts.all = _this2.postCollection.where(function (post) {
	          return post.categories.indexOf(VERDIEPING_KLANKBORDGROEP_CAT_ID) === -1 && post.categories.indexOf(VERDIEPING_ARCHIEF_CAT_ID) === -1 && post.categories.indexOf(VERDIEPING_ESSAYS_CAT_ID) === -1;
	        });
	        _this2.posts.first = _this2.posts.all;
	        _this2.posts.featured = _this2.postCollection.where(function (post) {
	          return post.categories.indexOf(FEATURED_CAT_ID) > -1;
	        });
	        _this2.posts.programma = _this2.postCollection.where(function (post) {
	          return post.categories.indexOf(EVENT_CAT_ID) > -1;
	        });
	        _this2.posts.programma.sort(function (a, b) {
	          if (a.date < b.date) {
	            return 1;
	          }
	          if (a.date > b.date) {
	            return -1;
	          }
	          return 0;
	        });
	        _this2.posts.nieuws = _this2.postCollection.where(function (post) {
	          return post.categories.indexOf(NIEUWS_CAT_ID) > -1;
	        });
	        _this2.posts.essays = _this2.postCollection.where(function (post) {
	          return post.categories.indexOf(VERDIEPING_ESSAYS_CAT_ID) > -1;
	        });
	        _this2.posts.archief = _this2.postCollection.where(function (post) {
	          return post.categories.indexOf(VERDIEPING_ARCHIEF_CAT_ID) > -1;
	        });
	        _this2.posts.klankbordgroep = _this2.postCollection.where(function (post) {
	          return post.categories.indexOf(VERDIEPING_KLANKBORDGROEP_CAT_ID) > -1;
	        });
	        var blog = _this2.postCollection.where(function (post) {
	          return post.categories.indexOf(BLOG_CAT_ID) > -1;
	        });
	
	        _this2.posts.blog = blog[0];
	        cb();
	      }, function (response) {
	        console.error(response);
	      });
	    },
	    fetchPages: function fetchPages(cb) {
	      var _this3 = this;
	
	      this.$http.get(BASE_URL + 'pages?per_page=100').then(function (response) {
	        for (var i = 0; i < response.body.length; i++) {
	          _this3.pageCollection.insert(response.body[i]);
	        }
	
	        _this3.meedoenPost = _this3.pageCollection.findOne({
	          id: MEEDOEN_ID
	        });
	
	        _this3.overonsPost = _this3.pageCollection.findOne({
	          id: OVERONS_ID
	        });
	
	        _this3.intro.programma = _this3.pageCollection.findOne({
	          id: PROGRAMMA_INTRO_ID
	        });
	
	        _this3.intro.nieuws = _this3.pageCollection.findOne({
	          id: NIEUWS_INTRO_ID
	        });
	
	        _this3.intro.verdieping = _this3.pageCollection.findOne({
	          id: VERDIEPING_INTRO_ID
	        });
	
	        _this3.intro.verdiepingArchief = _this3.pageCollection.findOne({
	          id: VERDIEPING_ARCHIEF_INTRO_ID
	        });
	        _this3.intro.verdiepingProgramma = _this3.pageCollection.findOne({
	          id: VERDIEPING_PROGRAMMA_INTRO_ID
	        });
	        _this3.intro.verdiepingEssays = _this3.pageCollection.findOne({
	          id: VERDIEPING_ESSAYS_INTRO_ID
	        });
	        _this3.intro.verdiepingMapping = _this3.pageCollection.findOne({
	          id: VERDIEPING_MAPPING_INTRO_ID
	        });
	        _this3.intro.verdiepingKlankbordgroep = _this3.pageCollection.findOne({
	          id: VERDIEPING_KLANKBORDGROEP_INTRO_ID
	        });
	        _this3.intro.verdiepingLinksNaarMeer = _this3.pageCollection.findOne({
	          id: VERDIEPING_LINKSNAARMEER_INTRO_ID
	        });
	
	        _this3.quotes = _this3.pageCollection.findOne({
	          id: QUOTES_ID
	        });
	
	        _this3.posts.verdieping = _this3.pageCollection.where(function (page) {
	          return page.parent === VERDIEPING_INTRO_ID;
	        });
	
	        cb();
	      }, function (response) {
	        console.error(response);
	      });
	    },
	    fetchTags: function fetchTags(cb) {
	      var _this4 = this;
	
	      this.$http.get(BASE_URL + 'tags?per_page=100').then(function (response) {
	        for (var i = 0; i < response.body.length; i++) {
	          _this4.tagCollection.insert(response.body[i]);
	        }
	        _this4.tags = response.body;
	        cb();
	      }, function (response) {
	        console.error(response);
	      });
	    },
	    fetchCategories: function fetchCategories(cb) {
	      var _this5 = this;
	
	      this.$http.get(BASE_URL + 'categories?per_page=100').then(function (response) {
	        for (var i = 0; i < response.body.length; i++) {
	          _this5.categoryCollection.insert(response.body[i]);
	        }
	        _this5.filters = _this5.categoryCollection.find({
	          parent: EVENT_CAT_ID
	        });
	        cb();
	      }, function (response) {
	        console.error(response);
	      });
	    },
	    mediaWatcher: function mediaWatcher() {
	      var _this6 = this;
	
	      var mq = window.matchMedia('(max-width: 520px)');
	      mq.addListener(function () {
	        if (mq.matches) {
	          _this6.screenSize.mobile = true;
	        } else {
	          _this6.screenSize.mobile = false;
	        }
	      });
	    },
	    toggleLogo: function toggleLogo() {
	      this.logoHidden = !this.logoHidden;
	    },
	    setLocation: function setLocation(newLoc) {
	      for (var key in this.location) {
	        if (Object.prototype.hasOwnProperty.call(this.location, key)) {
	          if (key === newLoc) {
	            this.location[key] = true;
	          } else {
	            this.location[key] = false;
	          }
	        }
	      }
	      if (!newLoc) {
	        this.location.home = true;
	      }
	    },
	    setLanguage: function setLanguage() {
	      if (this.$route.params.language === 'en') {
	        this.language = 'en';
	        document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
	      } else {
	        this.language = 'nl';
	        document.getElementsByTagName('html')[0].setAttribute('lang', 'nl');
	      }
	    }
	  },
	  watch: {
	    $route: function $route() {
	      var _this7 = this;
	
	      this.setLanguage();
	
	      if (!this.$route.name || this.$route.name === 'home') {
	        this.setLocation('home');
	      } else if (this.$route.name === 'single') {
	        var p = this.postCollection.where(function (post) {
	          return post.slug === _this7.$route.params.slug;
	        });
	        this.posts.single = p[0];
	        this.setLocation('single');
	      } else if (this.$route.name === 'overons') {
	        this.setLocation('overons');
	      } else if (this.$route.name === 'meedoen') {
	        this.setLocation('meedoen');
	      } else if (this.$route.name === 'programma') {
	        this.setLocation('programma');
	      } else if (this.$route.name === 'nieuws') {
	        this.setLocation('nieuws');
	      } else if (this.$route.name === 'verdieping') {
	        this.setLocation('verdieping');
	      } else if (this.$route.name === 'verdieping-archief') {
	        this.setLocation('verdieping-archief');
	      } else if (this.$route.name === 'verdieping-mapping') {
	        this.setLocation('verdieping-mapping');
	      } else if (this.$route.name === 'verdieping-essays') {
	        this.setLocation('verdieping-essays');
	      } else if (this.$route.name === 'verdieping-programma') {
	        this.setLocation('verdieping-programma');
	      } else if (this.$route.name === 'verdieping-links-naar-meer') {
	        this.setLocation('verdieping-links-naar-meer');
	      } else if (this.$route.name === 'verdieping-klankbordgroep') {
	        this.setLocation('verdieping-klankbordgroep');
	      } else if (this.$route.name === 'zoek') {
	        this.loaded.search = false;
	        this.$http.get(BASE_URL + 'posts?search=' + this.$route.params.slug).then(function (response) {
	          _this7.posts.search = response.body;
	          _this7.setLocation('zoek');
	          _this7.loaded.search = true;
	        }, function (response) {
	          console.error(response);
	        });
	      } else if (this.$route.name === 'tag') {
	        this.loaded.tagSearch = false;
	        var tempTag = this.tagCollection.findOne({
	          slug: this.$route.params.slug
	        });
	        this.posts.tag = this.postCollection.where(function (post) {
	          return post.tags.indexOf(tempTag.id) > -1;
	        });
	        this.setLocation('tag');
	        this.currentTag = tempTag;
	        this.loaded.tagSearch = true;
	      }
	      document.scrollingElement.scrollTop = 0;
	    },
	    'loaded.posts': function loadedPosts() {
	      this.$Progress.finish();
	    }
	  }
	};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsCalendarItem = __webpack_require__(197);
	
	var _dsCalendarItem2 = _interopRequireDefault(_dsCalendarItem);
	
	var _swiper = __webpack_require__(136);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dsCalendar',
	  calendarSlideShow: {},
	  components: {
	    dsCalendarItem: _dsCalendarItem2.default
	  },
	  props: ['language', 'posts'],
	  mounted: function mounted() {
	    this.calendarSlideShow = new _swiper2.default('#calendar-swiper-container', {
	      speed: 500,
	      autoplay: false,
	      loop: false,
	      spaceBetween: 30,
	      nextButton: '.button-next',
	      prevButton: '.button-prev'
	    });
	  },
	
	  computed: {
	    orderedList: function orderedList() {
	      var list = [];
	      var currentCounter = 0;
	      if (this.posts) {
	        this.posts.forEach(function (event) {
	          if (event.acf.dates) {
	            event.acf.dates.forEach(function (date) {
	              var nlDate = (0, _moment2.default)(date.date);
	              var enDate = (0, _moment2.default)(date.date);
	              nlDate.locale('nl');
	              enDate.locale('en');
	              var tempObj = {
	                slug: event.slug,
	                title: event.title.rendered,
	                title_en: event.acf.title_en,
	                fullDate: date.date,
	                date: nlDate.format('DD')
	              };
	              tempObj.en = {
	                month: enDate.format('MMM'),
	                day: enDate.format('ddd')
	              };
	              tempObj.nl = {
	                month: nlDate.format('MMM'),
	                day: nlDate.format('ddd')
	              };
	              if ((0, _moment2.default)().isBefore(nlDate)) {
	                currentCounter++;
	              }
	              list.push(tempObj);
	            });
	          }
	        });
	        list.sort(function (a, b) {
	          if (a.fullDate < b.fullDate) {
	            return -1;
	          } else if (a.fullDate > b.fullDate) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	        return list.slice(-currentCounter);
	      }
	    }
	  }
	};

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'dsCalendarItem',
	  props: ['language', 'item']
	};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsFeaturedItem = __webpack_require__(199);
	
	var _dsFeaturedItem2 = _interopRequireDefault(_dsFeaturedItem);
	
	var _swiper = __webpack_require__(136);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dsFeatured',
	  featuredPostSlideShow: {},
	  components: {
	    dsFeaturedItem: _dsFeaturedItem2.default
	  },
	  props: ['language', 'posts', 'tags'],
	  mounted: function mounted() {
	    this.featuredPostSlideShow = new _swiper2.default('#featured-swiper-container', {
	      speed: 1000,
	      autoplay: 8000,
	      pagination: '.swiper-pagination',
	      paginationClickable: true,
	      loop: true,
	      spaceBetween: 30
	    });
	  }
	};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsTagItemInline = __webpack_require__(8);
	
	var _dsTagItemInline2 = _interopRequireDefault(_dsTagItemInline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dsFeaturedItem',
	  props: ['language', 'item', 'tags'],
	  components: {
	    dsTagItemInline: _dsTagItemInline2.default
	  }
	};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _globalGrid = __webpack_require__(6);
	
	var _globalGrid2 = _interopRequireDefault(_globalGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dsFilterItem',
	  props: ['item', 'language'],
	  data: function data() {
	    return {
	      active: false
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    setTimeout(function () {
	      _globalGrid2.default.grid.on('arrangeComplete', function (e) {
	        if (_globalGrid2.default.grid.options.filter !== '.category-' + _this.item.id) {
	          _this.active = false;
	        }
	      });
	    }, 1000);
	  },
	
	  methods: {
	    filter: function filter() {
	      console.log('clicked');
	      console.dir(_globalGrid2.default.grid);
	      if (this.active === false) {
	        this.active = true;
	        _globalGrid2.default.grid.arrange({
	          filter: '.category-' + this.item.id
	        });
	      } else {
	        this.active = false;
	        _globalGrid2.default.grid.arrange({
	          filter: ''
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsMenu = __webpack_require__(7);
	
	var _dsMenu2 = _interopRequireDefault(_dsMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dsFooter',
	  components: {
	    dsMenu: _dsMenu2.default
	  },
	  props: ['language', 'location', 'screenSize']
	};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsGridItem = __webpack_require__(138);
	
	var _dsGridItem2 = _interopRequireDefault(_dsGridItem);
	
	var _isotopeLayout = __webpack_require__(178);
	
	var _isotopeLayout2 = _interopRequireDefault(_isotopeLayout);
	
	var _globalGrid = __webpack_require__(6);
	
	var _globalGrid2 = _interopRequireDefault(_globalGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dsGrid',
	  components: {
	    dsGridItem: _dsGridItem2.default
	  },
	  props: ['language', 'posts', 'tags', 'tag', 'search', 'location', 'screenSize', 'filter', 'filters'],
	  data: function data() {
	    return {
	      gridActive: false,
	      filtered: false
	    };
	  },
	  mounted: function mounted() {
	    this.initGrid();
	    this.gridActive = true;
	    this.setArrangeHandler();
	  },
	  destroyed: function destroyed() {
	    _globalGrid2.default.grid.destroy();
	  },
	
	  methods: {
	    initGrid: function initGrid() {
	      var el = document.querySelector('#grid');
	      _globalGrid2.default.grid = new _isotopeLayout2.default(el, {
	        itemSelector: '.grid-item',
	        transitionDuration: 0,
	        masonry: {
	          columnWidth: 316,
	          gutter: 30,
	          transitionDuration: 0
	        }
	      });
	    },
	    setArrangeHandler: function setArrangeHandler() {
	      var _this = this;
	
	      setTimeout(function () {
	        console.log('--- SETTING UP ARRANGE HANDLER');
	        console.dir(_globalGrid2.default.grid);
	        _globalGrid2.default.grid.on('arrangeComplete', function (e) {
	          if (_globalGrid2.default.grid.options.filter.length > 0 && _globalGrid2.default.grid.options.filter !== '*') {
	            console.log('rearranged');
	            var filterDescription = document.getElementById('filter-description');
	
	            var allDescriptions = [].slice.call(filterDescription.querySelectorAll('.category-description'));
	            allDescriptions.map(function (e) {
	              return e.classList.remove('shown');
	            });
	            console.log('filter 666666');
	            console.dir(_globalGrid2.default.grid.options.filter);
	            var activeDescription = filterDescription.querySelector(_globalGrid2.default.grid.options.filter);
	            console.log('desc');
	            console.dir(activeDescription);
	            if (activeDescription) {
	              _this.filtered = true;
	              activeDescription.classList.add('shown');
	            } else {
	              _this.filtered = false;
	            }
	          } else {
	            _this.filtered = false;
	          }
	        });
	      }, 500);
	    }
	  },
	  watch: {
	    $route: {
	      handler: function handler() {
	        var _this2 = this;
	
	        this.gridActive = false;
	        _globalGrid2.default.grid.destroy();
	        setTimeout(function () {
	          _this2.gridActive = true;
	          _this2.initGrid();
	          _this2.setArrangeHandler();
	        }, 500);
	      }
	    }
	  }
	};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsTagItemInline = __webpack_require__(8);
	
	var _dsTagItemInline2 = _interopRequireDefault(_dsTagItemInline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dsGridItem',
	  props: ['language', 'item', 'tags', 'location', 'screenSize'],
	  components: {
	    dsTagItemInline: _dsTagItemInline2.default
	  },
	  computed: {
	    classList: function classList() {
	      if (this.location.programma) {
	        var classObj = {};
	        if (this.item.categories) {
	          this.item.categories.forEach(function (category) {
	            classObj['category-' + category] = true;
	          });
	          return classObj;
	        }
	      } else {
	        return;
	      }
	    }
	  }
	};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsMarquee = __webpack_require__(205);
	
	var _dsMarquee2 = _interopRequireDefault(_dsMarquee);
	
	var _dsMenu = __webpack_require__(7);
	
	var _dsMenu2 = _interopRequireDefault(_dsMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dsHeader',
	  components: {
	    dsMarquee: _dsMarquee2.default,
	    dsMenu: _dsMenu2.default
	  },
	  data: function data() {
	    return {
	      searchTerm: ''
	    };
	  },
	
	  props: ['language', 'screenSize', 'quotes', 'loaded'],
	  computed: {
	    routeName: function routeName() {
	      if (this.$route.name) {
	        return this.$route.name;
	      } else {
	        return 'home';
	      }
	    },
	    routeSlug: function routeSlug() {
	      if (this.$route.params.slug) {
	        return this.$route.params.slug;
	      } else {
	        return 'home';
	      }
	    }
	  },
	  methods: {
	    search: function search() {
	      if (this.searchTerm) {
	        this.$parent.$router.push({
	          name: 'zoek',
	          params: {
	            lang: this.language,
	            slug: this.searchTerm
	          }
	        });
	        this.searchTerm = '';
	      }
	    }
	  }
	};

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var MAIL_URL = 'http://datastudio-eindhoven.nl/wp-content/themes/data_studio-2016-07-20-15-23-saltpond/subscribe.php?email=';
	exports.default = {
	  name: 'dsMailingList',
	  props: ['language'],
	  data: function data() {
	    return {
	      email: '',
	      firstName: '',
	      lastName: '',
	      formSubmitted: false
	    };
	  },
	
	  methods: {
	    send: function send() {
	      var _this = this;
	
	      console.log(this.firstName);
	      console.log(this.lastName);
	      this.$http.get(MAIL_URL + encodeURI(this.email) + '&first=' + encodeURI(this.firstName) + '&last=' + encodeURI(this.lastName)).then(function (response) {
	        console.log(response);
	        _this.formSubmitted = true;
	        _this.firstName = '';
	        _this.lastName = '';
	        _this.email = '';
	      }, function (response) {
	        console.error(response);
	      });
	    }
	  }
	};

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'dsMarquee',
	  props: ['language', 'quotes'],
	  computed: {
	    quoteStringNL: function quoteStringNL() {
	      var str = '';
	      for (var i = 0; i < this.quotes.acf.quotes.length; i++) {
	        str += ' ' + this.quotes.acf.quotes[i].quote;
	      }
	
	      return str + ' ' + str + ' ' + str + ' ' + str + ' ' + str + ' ' + str + ' ' + str + ' ' + str + ' ' + str;
	    },
	    quoteStringEN: function quoteStringEN() {
	      var str = '';
	      for (var i = 0; i < this.quotes.acf.quotes_en.length; i++) {
	        str += ' ' + this.quotes.acf.quotes_en[i].quote;
	      }
	
	      return str + ' ' + str + ' ' + str + ' ' + str + ' ' + str + ' ' + str + ' ' + str + ' ' + str + ' ' + str;
	    }
	  }
	};

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'dsMenu',
	  props: ['language']
	};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsTags = __webpack_require__(139);
	
	var _dsTags2 = _interopRequireDefault(_dsTags);
	
	var _dsFilterItem = __webpack_require__(200);
	
	var _dsFilterItem2 = _interopRequireDefault(_dsFilterItem);
	
	var _globalGrid = __webpack_require__(6);
	
	var _globalGrid2 = _interopRequireDefault(_globalGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dsSectionIntro',
	  components: {
	    dsTags: _dsTags2.default,
	    dsFilterItem: _dsFilterItem2.default
	  },
	  props: ['language', 'tags', 'loaded', 'introNL', 'introEN', 'screenSize', 'location', 'filters'],
	  methods: {
	    resetFilter: function resetFilter() {
	      _globalGrid2.default.grid.arrange({
	        filter: '*'
	      });
	    }
	  }
	};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsCalendar = __webpack_require__(196);
	
	var _dsCalendar2 = _interopRequireDefault(_dsCalendar);
	
	var _dsMailingList = __webpack_require__(204);
	
	var _dsMailingList2 = _interopRequireDefault(_dsMailingList);
	
	var _dsMenu = __webpack_require__(7);
	
	var _dsMenu2 = _interopRequireDefault(_dsMenu);
	
	var _truncate = __webpack_require__(191);
	
	var _truncate2 = _interopRequireDefault(_truncate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dsSideBar',
	  components: {
	    dsCalendar: _dsCalendar2.default,
	    dsMailingList: _dsMailingList2.default,
	    dsMenu: _dsMenu2.default
	  },
	  props: ['language', 'screenSize', 'posts', 'overons', 'loaded', 'location'],
	  data: function data() {
	    return {
	      mobileMenuActive: false
	    };
	  },
	
	  methods: {
	    toggleMobileMenu: function toggleMobileMenu() {
	      if (this.mobileMenuActive) {
	        this.mobileMenuActive = false;
	      } else {
	        this.mobileMenuActive = true;
	      }
	    },
	    makeHeightofMain: function makeHeightofMain() {
	      if (!window.matchMedia('(max-width: 520px)').matches) {
	        setTimeout(function () {
	          document.getElementById('sidebar').style.height = document.getElementById('main').clientHeight + 100 + 'px';
	        }, 1000);
	      } else {
	        document.getElementById('sidebar').style.height = '50px';
	      }
	    }
	  },
	  computed: {
	    smallBlogEN: function smallBlogEN() {
	      return (0, _truncate2.default)(this.posts.blog.acf.excerpt_en, 310);
	    },
	    smallBlogNL: function smallBlogNL() {
	      return (0, _truncate2.default)(this.posts.blog.acf.excerpt, 310);
	    }
	  },
	  watch: {
	    $route: {
	      handler: function handler() {
	        this.mobileMenuActive = false;
	        this.makeHeightofMain();
	      }
	    }
	  }
	};

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'dsTagItem',
	  props: ['language', 'item']
	};

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'dsTagItemInline',
	  props: ['tag', 'tags', 'language'],
	  data: function data() {
	    return {
	      name: '',
	      slug: '',
	      description: ''
	    };
	  },
	  created: function created() {
	    if (this.tags) {
	      var tempTag = this.tags.findOne({
	        id: this.tag
	      });
	      if (tempTag) {
	        this.name = tempTag.name;
	        this.slug = tempTag.slug;
	        this.description = tempTag.description;
	      }
	    }
	  }
	};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dsTagItem = __webpack_require__(208);
	
	var _dsTagItem2 = _interopRequireDefault(_dsTagItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dsTags',
	  components: {
	    dsTagItem: _dsTagItem2.default
	  },
	  props: ['language', 'tags']
	};

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'dsTeamItem',
	  props: ['language', 'item']
	};

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 12,
		"./af.js": 12,
		"./ar": 19,
		"./ar-dz": 13,
		"./ar-dz.js": 13,
		"./ar-kw": 14,
		"./ar-kw.js": 14,
		"./ar-ly": 15,
		"./ar-ly.js": 15,
		"./ar-ma": 16,
		"./ar-ma.js": 16,
		"./ar-sa": 17,
		"./ar-sa.js": 17,
		"./ar-tn": 18,
		"./ar-tn.js": 18,
		"./ar.js": 19,
		"./az": 20,
		"./az.js": 20,
		"./be": 21,
		"./be.js": 21,
		"./bg": 22,
		"./bg.js": 22,
		"./bm": 23,
		"./bm.js": 23,
		"./bn": 24,
		"./bn.js": 24,
		"./bo": 25,
		"./bo.js": 25,
		"./br": 26,
		"./br.js": 26,
		"./bs": 27,
		"./bs.js": 27,
		"./ca": 28,
		"./ca.js": 28,
		"./cs": 29,
		"./cs.js": 29,
		"./cv": 30,
		"./cv.js": 30,
		"./cy": 31,
		"./cy.js": 31,
		"./da": 32,
		"./da.js": 32,
		"./de": 35,
		"./de-at": 33,
		"./de-at.js": 33,
		"./de-ch": 34,
		"./de-ch.js": 34,
		"./de.js": 35,
		"./dv": 36,
		"./dv.js": 36,
		"./el": 37,
		"./el.js": 37,
		"./en-au": 38,
		"./en-au.js": 38,
		"./en-ca": 39,
		"./en-ca.js": 39,
		"./en-gb": 40,
		"./en-gb.js": 40,
		"./en-ie": 41,
		"./en-ie.js": 41,
		"./en-il": 42,
		"./en-il.js": 42,
		"./en-nz": 43,
		"./en-nz.js": 43,
		"./eo": 44,
		"./eo.js": 44,
		"./es": 47,
		"./es-do": 45,
		"./es-do.js": 45,
		"./es-us": 46,
		"./es-us.js": 46,
		"./es.js": 47,
		"./et": 48,
		"./et.js": 48,
		"./eu": 49,
		"./eu.js": 49,
		"./fa": 50,
		"./fa.js": 50,
		"./fi": 51,
		"./fi.js": 51,
		"./fo": 52,
		"./fo.js": 52,
		"./fr": 55,
		"./fr-ca": 53,
		"./fr-ca.js": 53,
		"./fr-ch": 54,
		"./fr-ch.js": 54,
		"./fr.js": 55,
		"./fy": 56,
		"./fy.js": 56,
		"./gd": 57,
		"./gd.js": 57,
		"./gl": 58,
		"./gl.js": 58,
		"./gom-latn": 59,
		"./gom-latn.js": 59,
		"./gu": 60,
		"./gu.js": 60,
		"./he": 61,
		"./he.js": 61,
		"./hi": 62,
		"./hi.js": 62,
		"./hr": 63,
		"./hr.js": 63,
		"./hu": 64,
		"./hu.js": 64,
		"./hy-am": 65,
		"./hy-am.js": 65,
		"./id": 66,
		"./id.js": 66,
		"./is": 67,
		"./is.js": 67,
		"./it": 68,
		"./it.js": 68,
		"./ja": 69,
		"./ja.js": 69,
		"./jv": 70,
		"./jv.js": 70,
		"./ka": 71,
		"./ka.js": 71,
		"./kk": 72,
		"./kk.js": 72,
		"./km": 73,
		"./km.js": 73,
		"./kn": 74,
		"./kn.js": 74,
		"./ko": 75,
		"./ko.js": 75,
		"./ky": 76,
		"./ky.js": 76,
		"./lb": 77,
		"./lb.js": 77,
		"./lo": 78,
		"./lo.js": 78,
		"./lt": 79,
		"./lt.js": 79,
		"./lv": 80,
		"./lv.js": 80,
		"./me": 81,
		"./me.js": 81,
		"./mi": 82,
		"./mi.js": 82,
		"./mk": 83,
		"./mk.js": 83,
		"./ml": 84,
		"./ml.js": 84,
		"./mn": 85,
		"./mn.js": 85,
		"./mr": 86,
		"./mr.js": 86,
		"./ms": 88,
		"./ms-my": 87,
		"./ms-my.js": 87,
		"./ms.js": 88,
		"./mt": 89,
		"./mt.js": 89,
		"./my": 90,
		"./my.js": 90,
		"./nb": 91,
		"./nb.js": 91,
		"./ne": 92,
		"./ne.js": 92,
		"./nl": 94,
		"./nl-be": 93,
		"./nl-be.js": 93,
		"./nl.js": 94,
		"./nn": 95,
		"./nn.js": 95,
		"./pa-in": 96,
		"./pa-in.js": 96,
		"./pl": 97,
		"./pl.js": 97,
		"./pt": 99,
		"./pt-br": 98,
		"./pt-br.js": 98,
		"./pt.js": 99,
		"./ro": 100,
		"./ro.js": 100,
		"./ru": 101,
		"./ru.js": 101,
		"./sd": 102,
		"./sd.js": 102,
		"./se": 103,
		"./se.js": 103,
		"./si": 104,
		"./si.js": 104,
		"./sk": 105,
		"./sk.js": 105,
		"./sl": 106,
		"./sl.js": 106,
		"./sq": 107,
		"./sq.js": 107,
		"./sr": 109,
		"./sr-cyrl": 108,
		"./sr-cyrl.js": 108,
		"./sr.js": 109,
		"./ss": 110,
		"./ss.js": 110,
		"./sv": 111,
		"./sv.js": 111,
		"./sw": 112,
		"./sw.js": 112,
		"./ta": 113,
		"./ta.js": 113,
		"./te": 114,
		"./te.js": 114,
		"./tet": 115,
		"./tet.js": 115,
		"./tg": 116,
		"./tg.js": 116,
		"./th": 117,
		"./th.js": 117,
		"./tl-ph": 118,
		"./tl-ph.js": 118,
		"./tlh": 119,
		"./tlh.js": 119,
		"./tr": 120,
		"./tr.js": 120,
		"./tzl": 121,
		"./tzl.js": 121,
		"./tzm": 123,
		"./tzm-latn": 122,
		"./tzm-latn.js": 122,
		"./tzm.js": 123,
		"./ug-cn": 124,
		"./ug-cn.js": 124,
		"./uk": 125,
		"./uk.js": 125,
		"./ur": 126,
		"./ur.js": 126,
		"./uz": 128,
		"./uz-latn": 127,
		"./uz-latn.js": 127,
		"./uz.js": 128,
		"./vi": 129,
		"./vi.js": 129,
		"./x-pseudo": 130,
		"./x-pseudo.js": 130,
		"./yo": 131,
		"./yo.js": 131,
		"./zh-cn": 132,
		"./zh-cn.js": 132,
		"./zh-hk": 133,
		"./zh-hk.js": 133,
		"./zh-tw": 134,
		"./zh-tw.js": 134
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 186;


/***/ }),
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/hni.a8586f6.svg";

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(177)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(140),
	  /* template */
	  __webpack_require__(228),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(171)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(141),
	  /* template */
	  __webpack_require__(222),
	  /* scopeId */
	  "data-v-7e09bcd7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(163)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(142),
	  /* template */
	  __webpack_require__(214),
	  /* scopeId */
	  "data-v-26cea30a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(166)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(143),
	  /* template */
	  __webpack_require__(217),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(175)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(144),
	  /* template */
	  __webpack_require__(226),
	  /* scopeId */
	  "data-v-f046c80c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(176)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(145),
	  /* template */
	  __webpack_require__(227),
	  /* scopeId */
	  "data-v-f689f4f8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(160)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(146),
	  /* template */
	  __webpack_require__(211),
	  /* scopeId */
	  "data-v-166c8cf4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(162)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(147),
	  /* template */
	  __webpack_require__(213),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(165)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(149),
	  /* template */
	  __webpack_require__(216),
	  /* scopeId */
	  "data-v-379ef0e6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(159)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(150),
	  /* template */
	  __webpack_require__(210),
	  /* scopeId */
	  "data-v-0f187300",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(164)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(151),
	  /* template */
	  __webpack_require__(215),
	  /* scopeId */
	  "data-v-2da69799",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(173)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(153),
	  /* template */
	  __webpack_require__(224),
	  /* scopeId */
	  "data-v-9b9ae9c0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(170)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(154),
	  /* template */
	  __webpack_require__(221),
	  /* scopeId */
	  "data-v-79efb49a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(169)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(155),
	  /* template */
	  __webpack_require__(220),
	  /* scopeId */
	  "data-v-715233c4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(168)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(158),
	  /* template */
	  __webpack_require__(219),
	  /* scopeId */
	  "data-v-6e6d78ae",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "newsletter"
	    }
	  }, [(_vm.language === "nl" && !_vm.formSubmitted) ? _c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Blijf op de"), _c('br'), _vm._v("Hoogte")]) : (_vm.language === "en" && !_vm.formSubmitted) ? _c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Stay up to"), _c('br'), _vm._v("date")]) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.formSubmitted) ? _c('span', {
	    staticClass: "bold"
	  }, [_vm._v("U bent geabonneerd op de nieuwsbrief")]) : (_vm.language === "en" && _vm.formSubmitted) ? _c('span', {
	    staticClass: "bold"
	  }, [_vm._v("Successfully subscribed to Newsletter")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form"
	  }, [(_vm.language === "nl" && !_vm.formSubmitted) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.firstName),
	      expression: "firstName"
	    }],
	    attrs: {
	      "type": "text",
	      "size": "40",
	      "placeholder": "Voornaam"
	    },
	    domProps: {
	      "value": (_vm.firstName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.firstName = $event.target.value
	      }
	    }
	  }) : (_vm.language === "nl" && !_vm.formSubmitted) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.lastName),
	      expression: "lastName"
	    }],
	    attrs: {
	      "type": "text",
	      "size": "40",
	      "placeholder": "Naam"
	    },
	    domProps: {
	      "value": (_vm.lastName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.lastName = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && !_vm.formSubmitted) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.firstName),
	      expression: "firstName"
	    }],
	    attrs: {
	      "type": "text",
	      "size": "40",
	      "placeholder": "First Name"
	    },
	    domProps: {
	      "value": (_vm.firstName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.firstName = $event.target.value
	      }
	    }
	  }) : (_vm.language === "en" && !_vm.formSubmitted) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.lastName),
	      expression: "lastName"
	    }],
	    attrs: {
	      "type": "text",
	      "size": "40",
	      "placeholder": "Last Name"
	    },
	    domProps: {
	      "value": (_vm.lastName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.lastName = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && !_vm.formSubmitted) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    attrs: {
	      "type": "email",
	      "placeholder": "Emailadres"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }) : (_vm.language === "en" && !_vm.formSubmitted) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    attrs: {
	      "type": "email",
	      "placeholder": "Email adress"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && !_vm.formSubmitted) ? _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "verstuur"
	    },
	    on: {
	      "click": _vm.send
	    }
	  }) : (_vm.language === "en" && !_vm.formSubmitted) ? _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "send"
	    },
	    on: {
	      "click": _vm.send
	    }
	  }) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', [_c('div', {
	    staticClass: "base-five border-top padding-top full-width margin-right"
	  }, [(_vm.screenSize.mobile || _vm.location.single || _vm.location["verdieping-programma"] || _vm.location["verdieping-mapping"] || _vm.location["verdieping-links-naar-meer"]) ? _c('dsMenu', {
	    attrs: {
	      "language": _vm.language
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    staticClass: "tag-item",
	    attrs: {
	      "to": {
	        name: 'tag',
	        params: {
	          language: _vm.language,
	          slug: _vm.slug
	        }
	      }
	    }
	  }, [(_vm.language === "en" && _vm.description) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.description)
	    }
	  }) : _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.name)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "padding-top",
	    class: {
	      active: this.gridActive
	    },
	    attrs: {
	      "id": "grid-wrapper"
	    }
	  }, [(_vm.tag) ? _c('div', {
	    staticClass: "padding-bottom"
	  }, [_vm._v("Tag:\n    "), _c('strong', [(_vm.language === "en" && _vm.tag.description) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.tag.description)
	    }
	  }) : _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.tag.name)
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.location.zoek && _vm.language === "nl") ? _c('div', {
	    staticClass: "padding-bottom"
	  }, [_vm._v("Zoekresultaten voor\n    "), _c('strong', [_vm._v(_vm._s(_vm.$route.params.slug))])]) : _vm._e(), _vm._v(" "), (_vm.location.zoek && _vm.language === "en") ? _c('div', {
	    staticClass: "padding-bottom"
	  }, [_vm._v("Search results for\n    "), _c('strong', [_vm._v(_vm._s(_vm.$route.params.slug))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.filtered && _vm.$route.name === "programma"),
	      expression: "filtered && $route.name === \"programma\""
	    }],
	    staticClass: "filter-description border-bottom margin-bottom",
	    attrs: {
	      "id": "filter-description"
	    }
	  }, _vm._l((_vm.filters), function(item) {
	    return _c('div', [(item.description.length > 0) ? _c('div', {
	      staticClass: "category-description",
	      class: "category-" + item.id
	    }, [(_vm.language === "nl" || item.acf.english_name.length < 1) ? _c('div', {
	      staticClass: "title"
	    }, [_c('strong', [_vm._v(_vm._s(item.name))])]) : _c('div', {
	      staticClass: "title"
	    }, [_c('strong', [_vm._v(_vm._s(item.acf.english_name))])]), _vm._v(" "), (_vm.language === "nl" || item.acf.english_description.length < 1) ? _c('div', {
	      staticClass: "description"
	    }, [_vm._v(_vm._s(item.description))]) : _c('div', {
	      staticClass: "description"
	    }, [_vm._v(_vm._s(item.acf.english_description))])]) : _vm._e()])
	  })), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "grid"
	    }
	  }, _vm._l((_vm.posts), function(item) {
	    return _c('dsGridItem', {
	      attrs: {
	        "item": item,
	        "language": _vm.language,
	        "tags": _vm.tags,
	        "location": _vm.location,
	        "screen-size": _vm.screenSize
	      }
	    })
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    staticClass: "calendar-item swiper-slide",
	    attrs: {
	      "to": {
	        name: 'single',
	        params: {
	          language: _vm.language,
	          slug: _vm.item.slug
	        }
	      }
	    }
	  }, [_c('div', {
	    staticClass: "large-numeral secondary-color light"
	  }, [_vm._v(_vm._s(_vm.item.date))]), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
	    staticClass: "date small-text secondary-color bold"
	  }, [_c('span', [_vm._v(_vm._s(_vm.item.nl.day))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.nl.month))])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
	    staticClass: "date small-text secondary-color bold"
	  }, [_c('span', [_vm._v(_vm._s(_vm.item.en.day))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.en.month))])]) : _vm._e(), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
	    staticClass: "calendar-description small-text secondary-color",
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.title)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
	    staticClass: "calendar-description small-text secondary-color",
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.title_en)
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "marquee",
	    attrs: {
	      "id": "marquee"
	    }
	  }, [(_vm.language === "nl") ? _c('span', [_vm._v(_vm._s(_vm.quoteStringNL))]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', [_vm._v(_vm._s(_vm.quoteStringEN))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [(_vm.screenSize.mobile === false) ? _c('div', {
	    staticClass: "base-five large-text high-light border-bottom"
	  }, [_vm._m(0), _vm._v(" "), (_vm.loaded.quotes && _vm.screenSize.mobile === false) ? _c('dsMarquee', {
	    attrs: {
	      "language": _vm.language,
	      "quotes": _vm.quotes
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('div', {
	    staticClass: "base-five border-bottom main-column"
	  }, [_c('dsMenu', {
	    attrs: {
	      "language": _vm.language
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('div', {
	    staticClass: "base-five border-bottom secondary-column"
	  }, [_c('div', {
	    staticClass: "search-field"
	  }, [(_vm.language === "nl") ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchTerm),
	      expression: "searchTerm"
	    }],
	    staticClass: "large-text secondary-color center-vertical",
	    attrs: {
	      "placeholder": "Zoek..."
	    },
	    domProps: {
	      "value": (_vm.searchTerm)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.search($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchTerm = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchTerm),
	      expression: "searchTerm"
	    }],
	    staticClass: "large-text secondary-color center-vertical",
	    attrs: {
	      "placeholder": "Search..."
	    },
	    domProps: {
	      "value": (_vm.searchTerm)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.search($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchTerm = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    on: {
	      "click": _vm.search
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "language-switch"
	  }, [_c('router-link', {
	    staticClass: "language-switch-button",
	    class: {
	      active: (_vm.language === "en")
	    },
	    attrs: {
	      "to": {
	        name: _vm.routeName,
	        params: {
	          language: 'en',
	          slug: _vm.routeSlug
	        }
	      }
	    }
	  }, [_vm._v("EN")]), _vm._v(" "), _c('router-link', {
	    staticClass: "language-switch-button",
	    class: {
	      active: (_vm.language === "nl")
	    },
	    attrs: {
	      "to": {
	        name: _vm.routeName,
	        params: {
	          language: 'nl',
	          slug: _vm.routeSlug
	        }
	      }
	    }
	  }, [_vm._v("NL")])], 1)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "quote-marks",
	    attrs: {
	      "id": "quote-marks"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(193)
	    }
	  })])
	}]}

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "featured-posts border-bottom padding-bottom"
	  }, [_c('div', {
	    staticClass: "swiper-container padding-top",
	    attrs: {
	      "id": "featured-swiper-container"
	    }
	  }, [_c('div', {
	    staticClass: "swiper-wrapper"
	  }, _vm._l((_vm.posts.featured), function(item) {
	    return _c('dsFeaturedItem', {
	      attrs: {
	        "item": item,
	        "language": _vm.language,
	        "tags": _vm.tags
	      }
	    })
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "swiper-pagination"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.location["verdieping-klankbordgroep"]) ? _c('div', {
	    staticClass: "grid-item focus-group",
	    class: _vm.classList
	  }, [_c('div', {
	    staticClass: "author small-text bold"
	  }, [_c('span', [_vm._v(_vm._s(_vm.item.title.rendered))])]), _vm._v(" "), _c('div', {
	    staticClass: "image-container"
	  }, [(_vm.language === "nl" && _vm.item.acf.image) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image.sizes['grid-small']),
	      expression: "item.acf.image.sizes['grid-small']"
	    }]
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image_en.sizes['grid-small']),
	      expression: "item.acf.image_en.sizes['grid-small']"
	    }]
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && !_vm.item.acf.image_en) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image.sizes['grid-small']),
	      expression: "item.acf.image.sizes['grid-small']"
	    }]
	  }) : _vm._e()]), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
	    staticClass: "description secondary-color small-text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.excerpt)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
	    staticClass: "description secondary-color small-text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.excerpt_en)
	    }
	  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.location["nieuws"]) ? _c('div', {
	    staticClass: "grid-item focus-group",
	    class: _vm.classList
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.item.acf.target_link,
	      "target": "_blank"
	    }
	  }, [_c('div', {
	    staticClass: "author small-text bold"
	  }, [_c('span', [_vm._v(_vm._s(_vm.item.title.rendered))])]), _vm._v(" "), _c('div', {
	    staticClass: "image-container"
	  }, [(_vm.language === "nl" && _vm.item.acf.image) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image.sizes['grid-small']),
	      expression: "item.acf.image.sizes['grid-small']"
	    }]
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.item.acf.image_en) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image_en.sizes['grid-small']),
	      expression: "item.acf.image_en.sizes['grid-small']"
	    }]
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && !_vm.item.acf.image_en) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image.sizes['grid-small']),
	      expression: "item.acf.image.sizes['grid-small']"
	    }]
	  }) : _vm._e()]), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
	    staticClass: "description secondary-color small-text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.excerpt)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
	    staticClass: "description secondary-color small-text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.excerpt_en)
	    }
	  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.location["verdieping-klankbordgroep"] && !_vm.location["nieuws"] && _vm.item.acf !== false) ? _c('div', {
	    staticClass: "grid-item",
	    class: _vm.classList
	  }, [_c('div', {
	    staticClass: "author small-text bold"
	  }, [_c('span', [_vm._v(_vm._s(_vm.item.acf.author))])]), _vm._v(" "), (_vm.location.verdieping) ? _c('router-link', {
	    staticClass: "roman",
	    attrs: {
	      "to": {
	        name: _vm.item.slug,
	        params: {
	          language: _vm.language
	        }
	      }
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [(_vm.language === "nl") ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.title.rendered)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.title_en)
	    }
	  }) : _vm._e()]), _vm._v(" "), (!_vm.screenSize.mobile) ? _c('div', {
	    staticClass: "tags"
	  }, _vm._l((_vm.item.tags), function(tag) {
	    return _c('dsTagItemInline', {
	      attrs: {
	        "tag": tag,
	        "tags": _vm.tags,
	        "language": _vm.language
	      }
	    })
	  })) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "image-container"
	  }, [(_vm.language === "nl" && _vm.item.acf.image) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image.sizes['grid-small']),
	      expression: "item.acf.image.sizes['grid-small']"
	    }]
	  }) : (_vm.language === "en" && _vm.item.acf.image_en) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image_en.sizes['grid-small']),
	      expression: "item.acf.image_en.sizes['grid-small']"
	    }]
	  }) : _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image.sizes['grid-small']),
	      expression: "item.acf.image.sizes['grid-small']"
	    }]
	  })])]) : _c('router-link', {
	    staticClass: "roman",
	    attrs: {
	      "to": {
	        name: 'single',
	        params: {
	          language: _vm.language,
	          slug: _vm.item.slug
	        }
	      }
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [(_vm.language === "nl") ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.title.rendered)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.title_en)
	    }
	  }) : _vm._e()]), _vm._v(" "), (!_vm.screenSize.mobile) ? _c('div', {
	    staticClass: "tags"
	  }, _vm._l((_vm.item.tags), function(tag) {
	    return _c('dsTagItemInline', {
	      attrs: {
	        "tag": tag,
	        "tags": _vm.tags,
	        "language": _vm.language
	      }
	    })
	  })) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "image-container"
	  }, [(_vm.language === "nl" && _vm.item.acf.image) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image.sizes['grid-small']),
	      expression: "item.acf.image.sizes['grid-small']"
	    }]
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.item.acf.image_en) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image_en.sizes['grid-small']),
	      expression: "item.acf.image_en.sizes['grid-small']"
	    }]
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && !_vm.item.acf.image_en) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.item.acf.image.sizes['grid-small']),
	      expression: "item.acf.image.sizes['grid-small']"
	    }]
	  }) : _vm._e()])]), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
	    staticClass: "description secondary-color small-text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.excerpt)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
	    staticClass: "description secondary-color small-text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.excerpt_en)
	    }
	  }) : _vm._e()], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "worker small-text"
	  }, [(_vm.language === "nl") ? _c('div', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.item.title))]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
	    staticClass: "italic"
	  }, [_vm._v(_vm._s(_vm.item.title_en))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "secondary-color strong"
	  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', [_c('a', {
	    attrs: {
	      "href": _vm.item["email_address"]
	    }
	  }, [_vm._v(_vm._s(_vm.item['email_address']))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.item['phone_number']))])])
	},staticRenderFns: []}

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    staticClass: "tag-item",
	    attrs: {
	      "to": {
	        name: 'tag',
	        params: {
	          language: _vm.language,
	          slug: _vm.item.slug
	        }
	      }
	    }
	  }, [(_vm.language === "en" && _vm.item.description) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.description)
	    }
	  }) : _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.name)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "sidebar",
	    attrs: {
	      "id": "sidebar"
	    }
	  }, [_c('div', {
	    staticClass: "base-five border-bottom",
	    attrs: {
	      "id": "title"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home',
	        params: {
	          language: _vm.language
	        }
	      }
	    }
	  }, [_c('svg', {
	    attrs: {
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "width": "172",
	      "height": "23.1",
	      "viewBox": "0 0 172 23.1"
	    }
	  }, [_c('defs', [_c('path', {
	    attrs: {
	      "id": "a",
	      "d": "M.5.2h171.1v22.6H.5z"
	    }
	  })]), _vm._v(" "), _c('clipPath', {
	    attrs: {
	      "id": "b"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xlink:href": "#a",
	      "overflow": "visible"
	    }
	  })]), _vm._v(" "), _c('path', {
	    attrs: {
	      "clip-path": "url(#b)",
	      "d": "M159.7 14.7c0-2.3.5-4.9 3-4.9 2.3 0 3 2.2 3 4.9 0 2.2-.5 4.9-3 4.9-.5 0-1.6-.1-2.2-1.2-.7-1.2-.8-2.7-.8-3.7m-6 0c0 1.9.4 4.2 2.2 5.9 1.5 1.4 3.7 2.3 7.1 2.3 3.2 0 5.1-1 6.4-2.2 1.6-1.6 2.2-3.9 2.2-6.1 0-5.5-3.9-8-8.9-8-6.1-.1-9 3.3-9 8.1m-8.3 7.8h5.8V7h-5.8v15.5zm0-18.1h5.9V.3h-5.9v4.1zm-11.9 15c-2.6 0-2.9-3.2-2.9-4.6 0-1.4.3-4.7 2.9-4.7 2 0 2.9 2 2.9 4.6.1 2.6-.8 4.7-2.9 4.7M136.4.2v8.6c-1-1.1-2.1-2.2-4.7-2.2-1.9 0-3.7.6-5.1 2.1-1 1.1-1.9 2.7-1.9 6 0 3.8 1.5 8.1 6.8 8.1 3.4 0 4.6-1.8 5.2-2.6l.1 2.3h5.5c-.1-1.3-.2-2.6-.2-3.8V.2h-5.7zM105.9 7v8.7c0 3 .3 7 5.7 7 1.4 0 3.3-.2 4.9-2.7l.1 2.4h5.7c0-1.2 0-1.4-.1-2.7V7h-5.8v9c0 .9 0 3.1-2.4 3.1-2.3 0-2.3-2.2-2.3-3V7h-5.8zm-5.7.1V2.5l-5.6 2.2v2.4h-3v3.7h2.9v7.4c0 3 .9 4.5 5.5 4.5 2 0 3-.2 3.8-.3v-3.6c-.7.1-1 .1-1.4.1-2.2 0-2.2-.9-2.2-2.8v-5.4h3.7V7.1h-3.7zM75.6 17.4c-.1 5 4.5 5.4 7.6 5.4 1.4 0 7.4 0 7.4-5.2 0-3-2.2-3.8-3.6-4.2l-4.1-1.1c-.9-.2-1.6-.6-1.6-1.5 0-1 .8-1.4 1.7-1.4.9 0 1.4.3 1.6.8.2.5.2 1 .2 1.5h5.5c-.2-4.3-3.7-5.2-7-5.2-2.3 0-4.1.4-5.5 1.3-1 .7-1.8 2-1.8 3.5 0 3.2 2.8 3.9 3.8 4.2l3.1.9c1.3.3 2.2.6 2.2 1.7 0 .7-.4 1.6-1.8 1.6-1 0-1.5-.5-1.7-1-.2-.5-.2-1.1-.2-1.4h-5.8zM64 3.3l4.1 10.9h-8.4L64 3.3zM53.2 22.5h3.2l2.4-5.8h10.3l2.4 5.8h3.4L65.9.3h-3.3l-9.4 22.2zm-4.8 0V2.9h7.4V.2H37.9v2.6h7.4v19.6h3.1zM29.6 3.3l4.1 10.9h-8.4l4.3-10.9zM18.8 22.5H22l2.4-5.8h10.3l2.4 5.8h3.4L31.5.3h-3.3l-9.4 22.2zM3.6 2.8h3.7c2.7 0 4.5.4 5.9 1.9 2.1 2.3 2.2 6.1 2.2 6.9 0 1.3-.1 4.9-2.9 7-1.5 1.1-3.7 1.2-5.8 1.2h-3v-17zM.5 22.5h6.2c3.3 0 6 0 8.2-1.8 1.7-1.4 3.7-4.3 3.7-9.1 0-3-.8-6.1-2.7-8.4C13.4.3 9.9.3 6.9.3H.5v22.2z"
	    }
	  })])]), _vm._v(" "), (_vm.screenSize.mobile === true) ? _c('div', {
	    staticClass: "three-bar",
	    on: {
	      "click": _vm.toggleMobileMenu
	    }
	  }, [_c('div', {
	    staticClass: "part"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "part"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "part"
	  })]) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === true && _vm.mobileMenuActive) ? _c('div', {
	    staticClass: "mobile-menu"
	  }, [_c('dsMenu', {
	    attrs: {
	      "language": _vm.language
	    }
	  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('div', {
	    staticClass: "small-blog"
	  }, [_c('div', {
	    staticClass: "blog-header base-five border-bottom"
	  }, [_c('div', {
	    staticClass: "menu-item small-text"
	  }, [(_vm.language === "nl") ? _c('span', {
	    staticClass: "small-text"
	  }, [_c('strong', [_vm._v("over DATAstudio")])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', {
	    staticClass: "small-text"
	  }, [_c('strong', [_vm._v("About DATAstudio")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "blog-content secondary-color border-bottom"
	  }, [(_vm.language === "nl") ? _c('div', {
	    staticClass: "blog-content-inner"
	  }, [_vm._v("\n        Er wordt nogal wat info verzameld over inwoners en de buurt waarin ze wonen, door gemeente en door bedrijven: allemaal data. Die data en datatechnologie worden ingezet om een stad slim te organiseren. Maar kun je ze ook gebruiken om als inwoners samen tot een fijnere buurt te komen?\n      ")]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
	    staticClass: "blog-content-inner"
	  }, [_vm._v("\n        Cities and private companies collect all sorts of information on people and the neighbourhoods they live in. That’s data. Data and data technology are used to organise cities in smarter ways. But can residents also use them to make their neighbourhood a nicer place?\n      ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'overons',
	        params: {
	          language: 'nl'
	        }
	      }
	    }
	  }, [_vm._v("Lees meer")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false && _vm.language === "nl" && _vm.loaded.pages) ? _c('div', {
	    staticClass: "about-container padding-top roman",
	    domProps: {
	      "innerHTML": _vm._s(_vm.overons.acf.short_text_nl)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false && _vm.language === "en" && _vm.loaded.pages) ? _c('div', {
	    staticClass: "about-container padding-top roman",
	    domProps: {
	      "innerHTML": _vm._s(_vm.overons.acf.short_text_en)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('a', {
	    staticClass: "small-hni-logo",
	    attrs: {
	      "href": "http://hetnieuweinstituut.nl/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(192)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('a', {
	    staticClass: "small-data-studio-logo",
	    attrs: {
	      "href": "http://datastudio-eindhoven.nl"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(137)
	    }
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "calendar-container border-bottom"
	  }, [_c('div', {
	    staticClass: "swiper-container padding-top",
	    attrs: {
	      "id": "calendar-swiper-container"
	    }
	  }, [_c('div', {
	    staticClass: "swiper-wrapper"
	  }, _vm._l((_vm.orderedList), function(item) {
	    return _c('dsCalendarItem', {
	      attrs: {
	        "item": item,
	        "language": _vm.language
	      }
	    })
	  }))]), _vm._v(" "), _vm._m(0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "calendar-nav"
	  }, [_c('span', {
	    staticClass: "button-prev secondary-color"
	  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
	    staticClass: "button-next secondary-color"
	  }, [_vm._v(">")])])
	}]}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "menu-item",
	    class: {
	      english: (_vm.language === "en")
	    }
	  }, [(_vm.language === "nl") ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'programma',
	        params: {
	          language: 'nl',
	          slug: ''
	        }
	      }
	    }
	  }, [_vm._v("Programma")]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'programma',
	        params: {
	          language: 'en',
	          slug: ''
	        }
	      }
	    }
	  }, [_vm._v("Programme")]) : _vm._e(), _vm._v(" "), (_vm.language === "nl") ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'overons',
	        params: {
	          language: 'nl',
	          slug: ''
	        }
	      }
	    }
	  }, [_vm._v("Over ons")]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'overons',
	        params: {
	          language: 'en',
	          slug: ''
	        }
	      }
	    }
	  }, [_vm._v("About")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "section-intro border-bottom padding-bottom"
	  }, [_c('div', {
	    staticClass: "main-area padding-top single-content"
	  }, [(_vm.location["verdieping-mapping"] || _vm.location["verdieping-programma"] || _vm.location["verdieping-links-naar-meer"] || _vm.location["verdieping-archief"] || _vm.location["verdieping-essays"] || _vm.location["verdieping-klankbordgroep"]) ? _c('router-link', {
	    staticClass: "strong",
	    attrs: {
	      "to": {
	        name: 'verdieping',
	        params: {
	          language: _vm.language
	        }
	      }
	    }
	  }, [(_vm.language === "nl") ? _c('span', [_vm._v("< Verdieping")]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', [_vm._v("< Context")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.loaded.posts) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.introNL)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.loaded.posts) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.introEN)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location.programma && "loaded.filters") ? _c('div', {
	    staticClass: "filters secondary-color large-text"
	  }, [_c('div', {
	    staticClass: "filter-item strong",
	    on: {
	      "click": _vm.resetFilter
	    }
	  }, [_vm._v("Filter")]), _vm._v(" "), _vm._l((_vm.filters), function(item) {
	    return _c('dsFilterItem', {
	      staticClass: "filter-item",
	      attrs: {
	        "item": item,
	        "language": _vm.language
	      }
	    })
	  })], 2) : _vm._e()], 1), _vm._v(" "), (_vm.screenSize.mobile === false && _vm.loaded.tags) ? _c('dsTags', {
	    staticClass: "secondary-area",
	    attrs: {
	      "language": _vm.language,
	      "tags": _vm.tags
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tag-container"
	  }, _vm._l((_vm.tags), function(item) {
	    return _c('dsTagItem', {
	      attrs: {
	        "item": item,
	        "language": _vm.language
	      }
	    })
	  }))
	},staticRenderFns: []}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "swiper-slide"
	  }, [_c('div', {
	    staticClass: "image-area float-left"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'single',
	        params: {
	          language: _vm.language,
	          slug: _vm.item.slug
	        }
	      }
	    }
	  }, [(_vm.language === "nl" && _vm.item.acf.image) ? _c('img', {
	    attrs: {
	      "src": _vm.item.acf.image.sizes['grid-large']
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.item.acf.image_en) ? _c('img', {
	    attrs: {
	      "src": _vm.item.acf.image_en.sizes['grid-large']
	    }
	  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
	    staticClass: "text-area float-left"
	  }, [_c('div', {
	    staticClass: "grid-item"
	  }, [_c('div', {
	    staticClass: "tags"
	  }, _vm._l((_vm.item.tags), function(tag) {
	    return _c('dsTagItemInline', {
	      attrs: {
	        "tag": tag,
	        "tags": _vm.tags,
	        "language": _vm.language
	      }
	    })
	  })), _vm._v(" "), _c('div', {
	    staticClass: "author small-text bold"
	  }, [_c('span', [_vm._v(_vm._s(_vm.item.acf.author))])]), _vm._v(" "), _c('router-link', {
	    staticClass: "title roman",
	    attrs: {
	      "to": {
	        name: 'single',
	        params: {
	          language: _vm.language,
	          slug: _vm.item.slug
	        }
	      }
	    }
	  }, [(_vm.language === "nl") ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.title.rendered)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.title_en)
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "description featured-description secondary-color small-text "
	  }, [(_vm.language === "nl") ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.excerpt)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.item.acf.excerpt_en)
	    }
	  }) : _vm._e()])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    class: {
	      "active": _vm.active
	    },
	    attrs: {
	      "data-cat": _vm.item.id
	    },
	    on: {
	      "click": _vm.filter
	    }
	  }, [(_vm.language === "en" && _vm.item.acf.english_name.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.item.acf.english_name))]) : _c('span', [_vm._v(_vm._s(_vm.item.name))])])
	},staticRenderFns: []}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('vue-progress-bar'), _vm._v(" "), (_vm.screenSize.mobile) ? _c('div', {
	    staticClass: "top-block"
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    class: {
	      "hidden": _vm.logoHidden
	    },
	    attrs: {
	      "id": "pop-up"
	    },
	    on: {
	      "click": _vm.toggleLogo
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(137)
	    }
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('dsSideBar', {
	    attrs: {
	      "screen-size": _vm.screenSize,
	      "posts": _vm.posts,
	      "overons": _vm.overonsPost,
	      "loaded": _vm.loaded,
	      "location": _vm.location,
	      "language": _vm.language
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "container"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('dsHeader', {
	    attrs: {
	      "screen-size": _vm.screenSize,
	      "quotes": _vm.quotes,
	      "loaded": _vm.loaded,
	      "language": _vm.language
	    }
	  })], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('main', {
	    staticClass: "full-width float-left margin-right",
	    attrs: {
	      "id": "main"
	    }
	  }, [_c('div', {
	    staticClass: "main-column"
	  }, [(_vm.location.overons && _vm.loaded.overons) ? _c('div', {
	    staticClass: "single-content float-left one-column-fixed-height border-bottom padding-bottom padding-top"
	  }, [(_vm.language === "nl" && _vm.loaded.posts) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.overonsPost.acf.header)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.loaded.posts) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.overonsPost.acf.header_en)
	    }
	  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.location.overons && _vm.loaded.overons) ? _c('div', {
	    staticClass: "single-content main-column padding-top",
	    domProps: {
	      "innerHTML": _vm._s(_vm.overonsPost.content.rendered)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.location.overons && _vm.loaded.overons) ? _c('div', {
	    staticClass: "single-content main-column padding-top",
	    domProps: {
	      "innerHTML": _vm._s(_vm.overonsPost.acf.main_text_en)
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.location.overons && _vm.loaded.overons) ? _c('aside', {
	    staticClass: "secondary-column float-left"
	  }, [_c('div', {
	    staticClass: "team-container border-bottom margin-bottom"
	  }, [(_vm.language === "nl") ? _c('div', {
	    staticClass: "padding-top margin-bottom center"
	  }, [_c('span', {
	    staticClass: "border-bottom strong"
	  }, [_vm._v("Wie zijn wij?")])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
	    staticClass: "padding-top margin-bottom center"
	  }, [_c('span', {
	    staticClass: "border-bottom strong"
	  }, [_vm._v("Who are we?")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.overonsPost.acf["wie_zijn_wij"]), function(item) {
	    return _c('dsTeamItem', {
	      attrs: {
	        "item": item,
	        "language": _vm.language
	      }
	    })
	  })], 2), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
	    staticClass: "center margin-bottom"
	  }, [_c('span', {
	    staticClass: "border-bottom strong"
	  }, [_vm._v("Pers")])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
	    staticClass: "center margin-bottom"
	  }, [_c('span', {
	    staticClass: "border-bottom strong"
	  }, [_vm._v("Press")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.overonsPost.acf.press), function(item) {
	    return _c('a', {
	      key: item.link,
	      staticClass: "press secondary-color strong margin-bottom",
	      attrs: {
	        "href": item.link,
	        "target": "_blank"
	      },
	      domProps: {
	        "innerHTML": _vm._s(item.text)
	      }
	    })
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.location.single && _vm.loaded.posts) ? _c('div', {
	    staticClass: "single-content main-column padding-top"
	  }, [(_vm.specialCategory) ? _c('div', [_c('router-link', {
	    staticClass: "strong no-underline",
	    attrs: {
	      "to": {
	        name: _vm.specialCategory.slug,
	        params: {
	          language: _vm.language
	        }
	      }
	    }
	  }, [(_vm.language === "nl") ? _c('span', [_vm._v("< " + _vm._s(_vm.specialCategory.name))]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', [_vm._v("< " + _vm._s(_vm.specialCategory.name))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.language === "nl") ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.posts.single.acf.main_text)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.posts.single.acf.main_text_en)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.screenSize.mobile === false) ? _c('p', {
	    staticClass: "secondary-color large-text uppercase margin-bottom light",
	    attrs: {
	      "id": "tags"
	    }
	  }, [_c('span', {
	    staticClass: "italic"
	  }, [_vm._v("TAGS")]), _vm._v(" "), _vm._l((_vm.posts.single.tags), function(tag) {
	    return _c('dsTagItemInline', {
	      attrs: {
	        "tag": tag,
	        "tags": _vm.tagCollection,
	        "language": _vm.language
	      }
	    })
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.language === "nl") ? _c('p', {
	    staticClass: "large-text secondary-color light"
	  }, [_c('span', {
	    staticClass: "high-light"
	  }, [_vm._v("DELEN")]), _vm._v(" "), _c('span', [_vm._v("op\n              "), _c('a', {
	    staticClass: "share-to-fb",
	    attrs: {
	      "href": ""
	    }
	  }, [_vm._v("Facebook")])])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('p', {
	    staticClass: "large-text secondary-color light"
	  }, [_c('span', {
	    staticClass: "high-light"
	  }, [_vm._v("SHARE")]), _vm._v(" "), _c('span', [_vm._v("on\n              "), _c('a', {
	    staticClass: "share-to-fb",
	    attrs: {
	      "href": ""
	    }
	  }, [_vm._v("Facebook")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.location.single && _vm.loaded.posts) ? _c('aside', {
	    staticClass: "secondary-column float-left"
	  }, [(_vm.loaded.tags) ? _c('dsTags', {
	    staticClass: "aside-tags border-bottom margin-bottom",
	    attrs: {
	      "tags": "tagCollection",
	      "language": _vm.language,
	      "tags": _vm.tags
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl") ? _c('div', {
	    staticClass: "center margin-bottom"
	  }, [_c('span', {
	    staticClass: "border-bottom strong"
	  }, [_vm._v("Lees ook")])]) : _vm._e(), _vm._v(" "), (_vm.language === "en") ? _c('div', {
	    staticClass: "center margin-bottom"
	  }, [_c('span', {
	    staticClass: "border-bottom strong"
	  }, [_vm._v("Related posts")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.relatedPosts), function(item) {
	    return _c('dsGridItem', {
	      attrs: {
	        "item": item,
	        "language": _vm.language,
	        "tags": _vm.tagCollection,
	        "location": _vm.location,
	        "screen-size": _vm.screenSize
	      }
	    })
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.location.verdieping && _vm.loaded.posts && _vm.loaded.pages) ? _c('dsSectionIntro', {
	    attrs: {
	      "language": _vm.language,
	      "loaded": _vm.loaded,
	      "location": _vm.location,
	      "screen-size": _vm.screenSize,
	      "introNL": _vm.intro.verdieping.content.rendered,
	      "introEN": _vm.intro.verdieping.acf.main_text_en,
	      "tags": _vm.tags
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location.verdieping && _vm.loaded.posts && _vm.loaded.pages) ? _c('dsGrid', {
	    attrs: {
	      "tags": _vm.tagCollection,
	      "location": _vm.location,
	      "screen-size": _vm.screenSize,
	      "posts": _vm.posts.verdieping,
	      "language": _vm.language
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location.home && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsFeatured', {
	    attrs: {
	      "posts": _vm.posts,
	      "screen-size": _vm.screenSize,
	      "tags": _vm.tagCollection,
	      "language": _vm.language
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location.home && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
	    attrs: {
	      "screen-size": _vm.screenSize,
	      "posts": _vm.posts.first,
	      "location": _vm.location,
	      "tags": _vm.tagCollection,
	      "language": _vm.language
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location.meedoen && _vm.loaded.meedoen) ? _c('div', {
	    staticClass: "single-content main-column float-left one-column-fixed-height border-bottom padding-bottom padding-top"
	  }, [(_vm.language === "nl" && _vm.loaded.posts) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.meedoenPost.acf.header)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.loaded.posts) ? _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.meedoenPost.acf.header_en)
	    }
	  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.location.meedoen && _vm.loaded.meedoen) ? _c('aside', {
	    staticClass: "secondary-column float-left"
	  }, [(_vm.loaded.tags) ? _c('dsTags', {
	    staticClass: "aside-tags border-bottom margin-bottom",
	    attrs: {
	      "language": _vm.language,
	      "tags": _vm.tags
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.location.nieuws && _vm.loaded.pages) ? _c('dsSectionIntro', {
	    attrs: {
	      "language": _vm.language,
	      "loaded": _vm.loaded,
	      "location": _vm.location,
	      "screen-size": _vm.screenSize,
	      "introNL": _vm.intro.nieuws.content.rendered,
	      "introEN": _vm.intro.nieuws.acf.main_text_en,
	      "tags": _vm.tags
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location.nieuws && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
	    attrs: {
	      "screen-size": _vm.screenSize,
	      "posts": _vm.posts.nieuws,
	      "tags": _vm.tagCollection,
	      "location": _vm.location,
	      "language": _vm.language
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location.programma && _vm.loaded.pages) ? _c('dsSectionIntro', {
	    attrs: {
	      "language": _vm.language,
	      "loaded": _vm.loaded,
	      "location": _vm.location,
	      "screen-size": _vm.screenSize,
	      "filters": _vm.filters,
	      "introNL": _vm.intro.programma.content.rendered,
	      "introEN": _vm.intro.programma.acf.main_text_en,
	      "tags": _vm.tags
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location.programma && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
	    attrs: {
	      "screen-size": _vm.screenSize,
	      "posts": _vm.posts.programma,
	      "filters": _vm.filters,
	      "location": _vm.location,
	      "tags": _vm.tagCollection,
	      "language": _vm.language
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location.zoek && _vm.loaded.search) ? _c('dsGrid', {
	    attrs: {
	      "screen-size": _vm.screenSize,
	      "posts": _vm.posts.search,
	      "location": _vm.location,
	      "search": _vm.currentSearchTerm,
	      "tags": _vm.tagCollection,
	      "language": _vm.language
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location.tag && _vm.loaded.tagSearch) ? _c('dsGrid', {
	    attrs: {
	      "screen-size": _vm.screenSize,
	      "posts": _vm.posts.tag,
	      "location": _vm.location,
	      "tag": _vm.currentTag,
	      "tags": _vm.tagCollection,
	      "language": _vm.language
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-archief"] && _vm.loaded.pages) ? _c('dsSectionIntro', {
	    attrs: {
	      "language": _vm.language,
	      "loaded": _vm.loaded,
	      "location": _vm.location,
	      "screen-size": _vm.screenSize,
	      "introNL": _vm.intro.verdiepingArchief.content.rendered,
	      "introEN": _vm.intro.verdiepingArchief.acf.main_text_en,
	      "tags": _vm.tags
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-archief"] && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
	    attrs: {
	      "screen-size": _vm.screenSize,
	      "posts": _vm.posts.archief,
	      "location": _vm.location,
	      "tags": _vm.tagCollection,
	      "language": _vm.language
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-programma"] && _vm.loaded.pages) ? _c('dsSectionIntro', {
	    attrs: {
	      "language": _vm.language,
	      "loaded": _vm.loaded,
	      "location": _vm.location,
	      "screen-size": _vm.screenSize,
	      "introNL": _vm.intro.verdiepingProgramma.content.rendered,
	      "introEN": _vm.intro.verdiepingProgramma.acf.main_text_en,
	      "tags": _vm.tags
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.location["verdieping-programma"] && _vm.loaded.pages) ? _c('div', {
	    staticClass: "single-content main-column padding-top",
	    domProps: {
	      "innerHTML": _vm._s(_vm.intro.verdiepingProgramma.acf.full_text)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.location["verdieping-programma"] && _vm.loaded.pages) ? _c('div', {
	    staticClass: "single-content main-column padding-top",
	    domProps: {
	      "innerHTML": _vm._s(_vm.intro.verdiepingProgramma.acf.full_text_en)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-essays"] && _vm.loaded.pages) ? _c('dsSectionIntro', {
	    attrs: {
	      "language": _vm.language,
	      "loaded": _vm.loaded,
	      "location": _vm.location,
	      "screen-size": _vm.screenSize,
	      "introNL": _vm.intro.verdiepingEssays.content.rendered,
	      "introEN": _vm.intro.verdiepingEssays.acf.main_text_en,
	      "tags": _vm.tags
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-essays"] && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
	    attrs: {
	      "screen-size": _vm.screenSize,
	      "posts": _vm.posts.essays,
	      "location": _vm.location,
	      "tags": _vm.tagCollection,
	      "language": _vm.language
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-mapping"]) ? _c('dsSectionIntro', {
	    attrs: {
	      "language": _vm.language,
	      "loaded": _vm.loaded,
	      "location": _vm.location,
	      "screen-size": _vm.screenSize,
	      "introNL": _vm.intro.verdiepingMapping.content.rendered,
	      "introEN": _vm.intro.verdiepingMapping.acf.main_text_en,
	      "tags": _vm.tags
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.location["verdieping-mapping"] && _vm.loaded.pages) ? _c('div', {
	    staticClass: "single-content main-column padding-top",
	    domProps: {
	      "innerHTML": _vm._s(_vm.intro.verdiepingMapping.acf.full_text)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.location["verdieping-mapping"] && _vm.loaded.pages) ? _c('div', {
	    staticClass: "single-content main-column padding-top",
	    domProps: {
	      "innerHTML": _vm._s(_vm.intro.verdiepingMapping.acf.full_text_en)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-links-naar-meer"] && _vm.loaded.pages) ? _c('dsSectionIntro', {
	    attrs: {
	      "language": _vm.language,
	      "loaded": _vm.loaded,
	      "location": _vm.location,
	      "screen-size": _vm.screenSize,
	      "introNL": _vm.intro.verdiepingLinksNaarMeer.content.rendered,
	      "introEN": _vm.intro.verdiepingLinksNaarMeer.acf.main_text_en,
	      "tags": _vm.tags
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "nl" && _vm.location["verdieping-links-naar-meer"] && _vm.loaded.pages) ? _c('div', {
	    staticClass: "single-content main-column padding-top",
	    domProps: {
	      "innerHTML": _vm._s(_vm.intro.verdiepingLinksNaarMeer.acf.full_text)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.language === "en" && _vm.location["verdieping-links-naar-meer"] && _vm.loaded.pages) ? _c('div', {
	    staticClass: "single-content main-column padding-top",
	    domProps: {
	      "innerHTML": _vm._s(_vm.intro.verdiepingLinksNaarMeer.acf.full_text_en)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-klankbordgroep"] && _vm.loaded.pages) ? _c('dsSectionIntro', {
	    attrs: {
	      "language": _vm.language,
	      "loaded": _vm.loaded,
	      "location": _vm.location,
	      "screen-size": _vm.screenSize,
	      "introNL": _vm.intro.verdiepingKlankbordgroep.content.rendered,
	      "introEN": _vm.intro.verdiepingKlankbordgroep.acf.main_text_en,
	      "tags": _vm.tags
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.location["verdieping-klankbordgroep"] && _vm.loaded.posts && _vm.loaded.tags) ? _c('dsGrid', {
	    attrs: {
	      "screen-size": _vm.screenSize,
	      "posts": _vm.posts.klankbordgroep,
	      "location": _vm.location,
	      "tags": _vm.tagCollection,
	      "language": _vm.language
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.loaded.posts) ? _c('dsFooter', {
	    attrs: {
	      "screen-size": _vm.screenSize,
	      "location": _vm.location,
	      "language": _vm.language
	    }
	  }) : _vm._e()], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.3ad9e29177e3ff684c2f.js